import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'filter-field-wrapper',
  templateUrl: './filter-field-wrapper.component.html',
  styleUrls: ['./filter-field-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterFieldWrapperComponent extends FieldWrapper {}
